var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8139 13.384L13.8324 44.5764L13.8076 13.3809L13.8139 13.384Z",
    fill: "#E29F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9943 34.6574L35.7132 4.56152L13.8135 13.3811L55.9943 34.6574Z",
    fill: "#976A00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9943 34.6572L13.8323 44.5748L13.8135 13.3809L55.9943 34.6572Z",
    fill: "#976A00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9921 34.6575L13.8135 13.384V13.3809L55.9921 34.6575Z",
    fill: "#976A00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1759 22.8889V60.8658L18.3447 42.4005V0.791016L47.3369 17.9569L47.8116 18.2397C48.4779 18.6872 49.0197 19.2955 49.4151 19.9982C49.9078 20.8655 50.1759 21.8726 50.1759 22.8889Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1152 26.7392V15.8223L29.8251 20.3874V31.2118L22.1152 26.7392Z",
    fill: "#F25C3E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5091 22.8267L31.0605 20.7852V22.1977L34.5091 24.1983V22.8267Z",
    fill: "#C7C7C7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2295 23.2539V24.6166L47.3389 31.6413V30.4235L35.2295 23.2539Z",
    fill: "#C7C7C7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.249 30.1807V31.4475L47.3391 33.8202V32.6023L43.249 30.1807Z",
    fill: "#C7C7C7"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8609 29.3593L31.0605 22.9648V24.3774L41.8609 30.643V29.3593Z",
    fill: "#C7C7C7"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0605 26.5565V25.1436L47.3388 34.7818V35.9993L31.0605 26.5565Z",
    fill: "#C7C7C7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1895 29.7671L31.0605 27.3223V28.7352L35.1895 31.1305V29.7671Z",
    fill: "#C7C7C7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3633 30.4619V31.8112L47.3386 38.1777V36.9605L36.3633 30.4619Z",
    fill: "#C7C7C7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3547 36.188L31.0605 29.501V30.9136L42.3547 37.4654V36.188Z",
    fill: "#C7C7C7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0752 36.6152V37.8839L47.339 40.3573V39.1397L43.0752 36.6152Z",
    fill: "#C7C7C7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3359 17.9567C45.0842 16.7946 42.5165 17.8291 41.5523 20.3087C41.2478 21.0904 41.1387 21.927 41.2023 22.7457L15.9858 8.11718C15.3803 7.39599 15.0125 6.46816 14.9422 5.50992C14.8905 4.85583 14.9758 4.18637 15.2191 3.5627C15.5142 2.80827 15.9921 2.2238 16.5731 1.83749C16.5731 1.83749 16.9017 1.64277 16.9077 1.63963C17.7928 1.1925 18.8549 1.17431 19.8435 1.68228C19.8711 1.69765 47.3359 17.9567 47.3359 17.9567Z",
    fill: "#C7C7C7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8135 13.3809L56 68.6701L13.8358 44.5701L13.8135 13.3809Z",
    fill: "#FFC233"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9981 34.6604V68.6726L13.832 44.5761L55.9922 34.6572H55.995L55.9981 34.6604Z",
    fill: "#E29F00"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5137 60.9023C51.5631 60.9732 51.6607 60.9908 51.7314 60.9414C51.8021 60.8917 51.8198 60.7937 51.7705 60.7227L50.832 59.377L51.5977 58.8379L52.5361 60.1836C52.8819 60.6794 52.7622 61.3627 52.2686 61.71C51.7747 62.0571 51.0939 61.9371 50.748 61.4414L49.2568 59.3027C49.5332 59.1534 49.7902 58.9728 50.0225 58.7646L51.5137 60.9023Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3759 51.7998C49.5715 51.7998 51.3514 53.5867 51.3514 55.791C51.3514 57.9953 49.5715 59.7822 47.3759 59.7822C45.1803 59.7822 43.4004 57.9953 43.4004 55.791C43.4004 53.5867 45.1803 51.7998 47.3759 51.7998ZM47.3759 52.7389C45.6969 52.7389 44.3357 54.1054 44.3357 55.7911C44.3357 57.4767 45.6969 58.8431 47.3759 58.8431C49.0549 58.8431 50.416 57.4767 50.416 55.7911C50.416 54.1054 49.0549 52.7389 47.3759 52.7389Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9069 56.8238C46.4748 57.6381 47.5927 57.836 48.4038 57.2658C48.8223 56.9717 49.0772 56.5313 49.1482 56.0605L50.073 56.2012C49.9653 56.9155 49.5771 57.5875 48.9404 58.0351C47.7061 58.9028 46.0049 58.6016 45.1406 57.3625L45.9069 56.8238Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4);
export default __webpack_public_path__ + "static/media/step4.084857a09434ebc94c6d0c518d9db266.svg";
export { ForwardRef as ReactComponent };